import React from 'react';
import PropTypes from 'prop-types';


const MobileCinemaFilter = ({ onClick, selectedCinema, cinemas, brand }) => (
  <div className={`react-cinema-filter-mobile-container${+brand !== 0 ? ' none' : ''}`}>
    <div className="react-filter-mobile-title">Válassz mozit!</div>
    <div className="react-filter-mobile-box" tabIndex={0} role="button" onClick={onClick}>
      <div className="react-cinema-filter-mobil-box-title">
        {selectedCinema !== 0 && cinemas !== null ? cinemas.find(cinema => cinema.id === +selectedCinema).name : 'Összes mozi'}
      </div>
    </div>
  </div>
);

MobileCinemaFilter.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedCinema: PropTypes.number.isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.shape({})),
  brand: PropTypes.number,
};

MobileCinemaFilter.defaultProps = {
  cinemas: null,
  brand: null,
};

export default MobileCinemaFilter;
